/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleOrderState.js'
import mutations from './moduleOrderMutations.js'
import actions from './moduleOrderActions.js'
import getters from './moduleOrderGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
